"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportDataCacheVersionedT = exports.ReportDataCacheT = exports.ReportVersion = exports.ReportVersionT = exports.ReportParamT = exports.ReportJobT = exports.ReportJobReportT = exports.ReportExportTypeT = void 0;
const tBox = __importStar(require("@sinclair/typebox"));
const dates_1 = require("./dates");
const meta_types_1 = require("./meta-types");
exports.ReportExportTypeT = tBox.Union([
    tBox.Literal(1, { description: 'PDF' }),
    tBox.Literal(2, { description: 'XLSX' }),
    tBox.Literal(3, { description: 'CSV' }),
]);
exports.ReportJobReportT = tBox.Object({
    ID: tBox.Number(),
    ReportJob: tBox.Number(),
    Type: tBox.String(),
    Name: tBox.String(),
    ExportType: exports.ReportExportTypeT,
    Params: (0, meta_types_1.ModelStrT)(tBox.Any()),
    OverriddenParams: tBox.Union([tBox.Undefined(), tBox.Array(tBox.String())]),
});
exports.ReportJobT = tBox.Object({
    ID: tBox.Number(),
    Name: tBox.String(),
    Hidden: meta_types_1.tBoolT,
    Created: tBox.Union([meta_types_1.tDatetimeT, (0, dates_1.DateTimeObjT)()]),
    BaseParams: (0, meta_types_1.ModelStrT)(tBox.Any()),
    Reports: (0, meta_types_1.ModelTypeT)(exports.ReportJobReportT),
});
exports.ReportParamT = tBox.Object({
    Key: tBox.String(),
    BundlingLabel: (0, meta_types_1.MaybeT)(tBox.String()),
    Type: tBox.String(),
    Label: tBox.String(),
    Default: tBox.Any(),
    Nullable: tBox.Boolean(),
    Options: (0, meta_types_1.MaybeT)(tBox.Array(tBox.Object({
        value: tBox.String(),
        text: tBox.String(),
    }))),
});
exports.ReportVersionT = tBox.Union([tBox.Literal('v3'), tBox.Literal('v4')]);
var ReportVersion;
(function (ReportVersion) {
    ReportVersion["V3"] = "v3";
    ReportVersion["V4"] = "v4";
})(ReportVersion || (exports.ReportVersion = ReportVersion = {}));
exports.ReportDataCacheT = tBox.Object({
    params: (0, meta_types_1.ModelStrT)((0, meta_types_1.ModelTypeT)(exports.ReportParamT)),
    exports: (0, meta_types_1.ModelStrT)(tBox.Array(exports.ReportExportTypeT)),
});
exports.ReportDataCacheVersionedT = tBox.Object({
    params: (0, meta_types_1.ModelStrT)((0, meta_types_1.ModelTypeT)(exports.ReportParamT)),
    exports: (0, meta_types_1.ModelStrT)(tBox.Array(exports.ReportExportTypeT)),
    version: (0, meta_types_1.ModelStrT)(exports.ReportVersionT),
});
//# sourceMappingURL=types-reports.js.map